import { createNamedContext } from '@core/createNamedContext'

export const WebsiteModuleContext = createNamedContext('WebsiteModuleContext', {
  moduleType: null as string | null,
  moduleId: null as string | null,
})
